/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.uploadModule')

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  .directive('bulbUpload', ['$timeout', bulbUploadFactory]);

/**
 * A directive for an upload control.
 * Use it as the element bulb-upload, with attributes as needed:
 *
 *  asset-definitions-key: Required: added to the query parameters on the upload request. For example:
 *      <bulb-upload asset-definitions-key="coverImage"/>Browse</bulb-upload>
 *  asset-type: Required: used to compose the upload URL. For example:
 *      <bulb-upload asset-type="image"/>Browse</bulb-upload>
 *  file-extensions: if set, a string containing a comma-separated list of permitted file extensions,
 *    used to configure a file extension filter in Plupload. For example:
 *      <bulb-upload file-extensions="jpg,jpeg,bmp,gif,png"/>Browse</bulb-upload>
 *  on-file-uploaded: if set, configure a function to be called when a file has been uploaded.
 *    If defined, the function is called with a single argument $response,
 *    set to the restReply returned by the server in response to the upload request. For example:
 *      <bulb-upload on-file-uploaded="someCtrl.someFunction($response)"/>Browse</bulb-upload>
 *    This function should return a promise.
 *  upload-label: the label for the control shown when the upload control is inactive, to activate it.
 *  use-button: if set, this will use a button instead of simple text to show the upload.
 *  button-class: the class that the button will use when applied.
 *  font-awesome-prefix: the prefix for the font awesome icon used on the button.
 *  font-awesome-code: the code for the font awesome icon used on the button.
 *  minImageWidth: the minimum width size of the image that can be uploaded.
 *  minImageHeight: the minimum height size of the image that can be uploaded.
 *
 * This directive transcludes its contents as the label for the "Browse" button.
 */
function bulbUploadFactory($timeout) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/upload/upload.html',
    controller: 'BulbUploadController as uploadCtrl',
    bindToController: true,
    scope: {
      assetDefinitionsKey: '@',
      assetType: '@',
      fileExtensions: '@',
      isActive: '=',
      useButton: '=',
      buttonClass: '@',
      fontAwesomePrefix: '@',
      fontAwesomeCode: '@',
      onFileUploaded: '=',
      uploadLabel: '@',
      customClass: '@',
    },
    transclude: true,
    link(scope, elem) {
      /**
       * Show the error message tooltip, but arrange to hide it if the user clicks the tooltip.
       * The tooltip, when it appears, is the very next element in the DOM after the wrapper.
       */
      function showTooltip() {
        $timeout(() => {
          const wrapper = jQuery('.bulb-progressbar-wrapper', elem);
          wrapper.trigger('showTooltip');
          scope.$evalAsync(() => {
            const tooltip = wrapper.next('.tooltip');
            if (tooltip.length > 0) {
              tooltip.on('click', hideTooltip);
              scope.uploadCtrl.isTooltipHidden = false;
            }
          });
        });
      }

      /**
       * Hide the error message tooltip, but arrange to show it again if the user clicks the progress bar.
       */
      function hideTooltip() {
        $timeout(() => {
          const wrapper = jQuery('.bulb-progressbar-wrapper', elem);
          wrapper.trigger('hideTooltip');
          wrapper.on('click', showTooltip);
          scope.uploadCtrl.isTooltipHidden = true;
        });
      }

      /**
       * Automatically display the error message tooltip, when there is an error message.
       */
      scope.$watch('uploadCtrl.errorMessage', (errorMessage) => {
        if (errorMessage) {
          showTooltip();
        }
      });
    },
  };
}
